import { format } from "date-fns";
import { cn, useAppointmentsMiscellaneous } from "../../../shared/utils";
import { CamIcon, HospitalIcon } from "../../../shared/svgIcon";
import { updateUnAuthAppointmentsStatus } from "../../../lib/api";
import { toast } from "sonner";

export const calculateAge = (dateOfBirth) => {
  const dob = new Date(dateOfBirth);
  const currentDate = new Date();

  let age = currentDate.getFullYear() - dob.getFullYear();
  const monthDifference = currentDate.getMonth() - dob.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && currentDate.getDate() < dob.getDate())
  ) {
    age--;
  }
  return age;
};
export const getGender = (short) => {
  let gender = "";
  switch (short?.toLocaleUpperCase()) {
    case "M":
      gender = "Male";
      break;
    case "F":
      gender = "Female";
      break;
    case "O":
      gender = "Other";
      break;
    default:
      gender = "";
      break;
  }
  return gender;
};

export function EventDetail({ event,onHandleClose }) {
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();
  const {
    consumer: patientDetails,
    start_time,
    end_time,
    status,
    appointment_type,
    organization,
    id,
  } = event;

  const getStatus = (key) => {
    return appointmentsMisc?.data?.result?.appointment_status_types?.filter(
      (e) => e.key === key
    )[0]?.label;
  };

  const handleReject = async () => {
    const payload = {
      status: "canceled",
    };
    const res = await updateUnAuthAppointmentsStatus(id, payload);
    if(res.isSuccess){
      onHandleClose()
      toast("Appointment Cancelled.")
    }
    
  };
  const handleAccept = async () => {
    const payload = {
      status: "scheduled",
    };
    const res = await updateUnAuthAppointmentsStatus(id, payload);
    if(res.isSuccess){
    onHandleClose()
    toast("Appointment Scheduled.")
    }
  };
  return (
    <div
      className={cn(
        "  ",
        "bg-white  p-4 appointment-card-hold overflow-y-auto hideScroll"
      )}
    >
      <div className="text-blue-800 font-semibold text-lg capitalize">
        {patientDetails?.profile?.first_name}{" "}
        {patientDetails?.profile?.middle_name}{" "}
        {patientDetails?.profile?.last_name}
      </div>
      <div className="text-gray-600 text-sm">
        {patientDetails?.dob && (
          <span>{calculateAge(patientDetails?.dob)} years old,</span>
        )}{" "}
        {patientDetails?.gender && (
          <span>{getGender(patientDetails?.gender)}</span>
        )}
      </div>
      <div className="text-gray-800 font-semibold text-base mt-2">
        {organization?.name}
        <br />
        <div className="text-sm font-normal">
          <span className="pr-2">{organization?.address?.street},</span>
          <span className="pr-2">{organization?.address?.city},</span>
          <span className="pr-2">{organization?.address?.state}</span>

          <span className="pr-2">{organization?.address?.postal_code}</span>
        </div>

        {organization?.contact?.filter((e) => e.type == "phone").length > 0 && (
          <div className="text-sm font-normal">
            Tel:{" "}
            <a
              href={`tel:${
                organization?.contact?.find(
                  (contact) => contact.type === "phone"
                )?.value
              }`}
              className=""
            >
              {
                organization?.contact?.find(
                  (contact) => contact.type === "phone"
                )?.value
              }
            </a>
          </div>
        )}
      </div>
      <div className="text-gray-800  mt-2">
        <div className="font-semibold text-base">Time</div>
        <div className="text-sm font-semibold flex items-center ">
          {start_time && (
            <>
              <p className="pr-1 font-semibold ">
                {format(new Date(start_time), "MMM")}
              </p>
              <p className="font-semibold ">
                {format(new Date(start_time), "dd")}
              </p>
              ,
              <p className="pr-1 font-semibold ">
                {format(new Date(start_time), "yyyy")}
              </p>
              <p className="pl-1 font-semibold ">
                {format(new Date(start_time), "EEE")}
              </p>
              ,
            </>
          )}
          {start_time && end_time && (
            <div className="flex flex-row gap-2 font-semibold  pl-1">
              <p> {format(new Date(start_time), "h:mm a")}</p> <p>-</p>
              <p> {format(new Date(end_time), "h:mm a")}</p>
            </div>
          )}
        </div>
      </div>
      <div className="text-gray-800  mt-2">
        <div className="font-semibold text-base">Type</div>
        <div
          className={`flex items-center cursor-pointer  text-sm text-white  py-1 px-2 rounded-[10px] border w-[110px] mt-1 ${
            appointment_type == "virtual_visit"
              ? "bg-green-500  border-green-500"
              : "bg-orange-500 border-orange-500"
          }`}
        >
          {appointment_type == "virtual_visit" ? <CamIcon /> : <HospitalIcon />}{" "}
          <p className="px-1">
            {appointment_type == "virtual_visit" ? "Video call" : "In Person"}
          </p>
        </div>
      </div>
      <div className="text-gray-800 mt-4">
        <div className="font-semibold text-base ">Status</div>
        <div className={` text-sm rounded-full  text-slate-700`}>
          {getStatus(status)}
        </div>
      </div>
      <div className="flex flex-row gap-3 mt-4">
        <button
          className="border border-blue-500  text-blue-500 text-sm py-2 px-6 rounded-md focus:outline-none w-min font-semibold"
          onClick={handleAccept}
        >
          Accept
        </button>
        <button
          className="border border-red-500 text-red-500 text-sm py-2 px-6 rounded-md focus:outline-none w-min font-semibold"
          onClick={handleReject}
        >
          Reject
        </button>
      </div>
    </div>
  );
}
